export class GcpOrganization {
    'id';
    'name';
    'organizationId';
    'folderId';
    'managementProjectId';
    'managementServiceAccountId';
    'state';
    'excludeProjectPatterns';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "organizationId",
            "baseName": "organizationId",
            "type": "string",
            "format": ""
        },
        {
            "name": "folderId",
            "baseName": "folderId",
            "type": "string",
            "format": ""
        },
        {
            "name": "managementProjectId",
            "baseName": "managementProjectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "managementServiceAccountId",
            "baseName": "managementServiceAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "state",
            "baseName": "state",
            "type": "AccountState",
            "format": ""
        },
        {
            "name": "excludeProjectPatterns",
            "baseName": "excludeProjectPatterns",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpOrganization.attributeTypeMap;
    }
    constructor() {
    }
}
